export default __webpack_public_path__ + "static/media/mySugr-reg.c62ac7a3.svg";